import { PerNgPlatformService } from '@pershing/per-ng-platform-service';
import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PortalService {

  private _portalConfigUrl = 'assets/portal-config.json';
  private _portalConfig: { [key: string]: any } = {};

  constructor(
    private _platformService: PerNgPlatformService,
    private _http: HttpClient, @Optional() @Inject('AppSettings') appSettings: any) {
    this._http.get(this._portalConfigUrl).subscribe(data => this._portalConfig = data);
    this._platformService.setAppSettings(appSettings);
    this._platformService.setHome(!!appSettings?.home ? appSettings.home : '/home');
    this._platformService.setLogoutPage(!!appSettings?.logout ? appSettings.logout : '/login');
    this._platformService.setUserId(appSettings.isLoggedIn);
  }

  getElementConfig(elementName: string) {
    if(this._platformService.getAppSettings().isForLocal) {
        let elObj = this._portalConfig['elements'];
        return elObj && elObj[elementName] ? elObj[elementName] : null;
    } else {
        return this.getAppSetting("elementConfig") && this.getAppSetting("elementConfig")[elementName] ? 
          this.getAppSetting("elementConfig")[elementName] : null;
    }
  }

  getPortalConfig(configName: string): any {
    return !!configName && this._portalConfig && this._portalConfig[configName] ?
      this._portalConfig[configName] : null;
  }

  getAppSetting(configName: string): any {
    let asObj = this._platformService.getAppSettings();
    return !!configName && asObj && asObj[configName] ? asObj[configName] : null;
  }

}
